import React from "react";

function EmergencyCta({ className = "" }) {
	return (
		<div
			className={`flex flex-col items-center gap-6 rounded-2xl border border-gray-100 bg-white px-6 py-6 shadow-[0_8px_30px_rgba(0,0,0,0.08)] md:flex-row md:gap-8 md:px-8 md:py-7 ${className}`}
		>
			<div className="flex h-[88px] w-[88px] shrink-0 items-center justify-center rounded-full bg-[#F8E8E8] text-[28px] font-bold leading-none text-[#9A201D] md:h-[100px] md:w-[100px] md:text-[32px]">
				24/7
			</div>
			<div className="flex-1 text-center md:text-left">
				<p className="flex items-center justify-center gap-2 text-[11px] font-semibold tracking-[0.16em] text-[#9A201D] md:justify-start">
					<span className="h-1.5 w-1.5 rounded-full bg-[#9A201D]"></span>
					EMERGENCY SUPPORT
				</p>
				<h3 className="mt-2 text-xl font-bold text-gray-900 md:text-[26px] md:leading-snug">
					Need immediate assistance? We are here for you.
				</h3>
				<p className="mt-2 text-sm leading-relaxed text-gray-500 md:text-[15px]">
					Our service technicians are on call round-the-clock to
					handle urgent barn curtain, power ventilation, or
					controller issues. Your livestock&apos;s comfort
					doesn&apos;t wait, and neither do we.
				</p>
			</div>
			<a
				href="tel:715-255-2355"
				className="shrink-0 whitespace-nowrap rounded-md bg-[#9A201D] px-6 py-3.5 text-sm font-bold tracking-wide text-white transition hover:bg-[#7d1a18]"
			>
				CALL 715-255-2355
			</a>
		</div>
	);
}

export default EmergencyCta;
